<template>
	<v-overlay :dark="false" absolute :value="showModal">
		<div class="input-modal">
			<div class="input-modal-header">
				<h3>Merge Customers</h3>
				<v-btn icon @click="$emit('cancel')">
					<v-icon v-text="'mdi-close'"></v-icon>
				</v-btn>
			</div>
			<div class="input-modal-content">
				<p class="mb-2">Customer to merge</p>
				<form class="input-modal-content-form">
					<v-row>
						<v-col cols="12" class="input-modal-content-form-item">
							<v-text-field
								outlined
								dense
								label="Customer Number"
								hide-details="auto"
								v-model="mergeData.customerNumber"
								class="number-input"
								type="number"
							></v-text-field>
						</v-col>
					</v-row>
				</form>

				<p class="mt-3 mb-2">Customer to merge into</p>
				<form class="input-modal-content-form">
					<v-row>
						<v-col cols="12" class="input-modal-content-form-item">
							<v-text-field
								outlined
								dense
								label="Customer Number"
								hide-details="auto"
								v-model="mergeData.mergeCustomerNumber"
								class="number-input"
								type="number"
							></v-text-field>
						</v-col>
					</v-row>
				</form>

				<div class="input-modal-content-actions">
					<v-btn outlined small @click="$emit('cancel')">Cancel</v-btn>
					<v-btn small color="primary" @click="$emit('cancel')">Merge</v-btn>
				</div>
			</div>
		</div>
	</v-overlay>
</template>

<script>
export default {
	name: "MergeCustomer",
	props: {
		showModal: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {
			mergeData: {
				customerNumber: "",
				mergeCustomerNumber: "",
			},
		};
	},
};
</script>

<style lang="scss" scoped>
.input-modal {
	width: 40vw;
	margin: auto;
	border-radius: 3px;
	overflow: hidden;
	box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;

	&-header {
		position: relative;
		display: flex;
		width: 100%;
		flex-flow: row nowrap;
		align-items: center;
		background-color: $color-white;
		padding: 1rem;
		border-bottom: 1px solid $color-gray;

		h3 {
			font-size: 1.6rem;
		}

		.v-btn {
			position: absolute;
			right: 1rem;
		}
	}

	&-content {
		display: block;
		width: 100%;
		background-color: $color-white;
		color: $color-black;
		padding: 2rem;

		h3 {
			margin: auto;
			margin-bottom: 0.8rem;
			text-align: center;
			font-size: 1.4rem;
		}

		p {
			font-size: 1.4rem;
		}

		&-form {
			display: block;

			&-item {
				margin-bottom: 1.5rem;
				text-align: center;

				label {
					margin-right: 2rem;
				}

				input[type="number"] {
					text-align: right;
					padding: 0 0.2rem;
					border: 1px solid $color-gray-dark;
					border-radius: 3px;
					background-color: $color-white;

					&:focus {
						border-color: $color-primary;
					}
				}
			}
		}

		&-actions {
			display: flex;
			width: 100%;
			justify-content: flex-end;

			.v-btn {
				margin: 0.6rem;
				font-size: 1.2rem;
				width: 8rem;

				&.v-btn--outlined {
					border-color: $color-gray;
				}
			}
		}
	}
}
</style>
